import React, { useEffect, useState, useRef } from 'react';
import { Typography, CircularProgress, Button } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';

function ConfirmEmail() {
  const [searchParams] = useSearchParams();
  const [message, setMessage] = useState('Confirming your account...');
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const alreadyCalled = useRef(false);

  useEffect(() => {
    if (alreadyCalled.current) return;
    alreadyCalled.current = true;

    const confirmEmail = async () => {
      const token = searchParams.get('token');

      if (!token) {
        setMessage('Invalid confirmation link.');
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(
          `https://api.hub4food.colab4food.com/api/confirm-email?token=${token}`
        );

        const data = await response.json();

        if (response.ok) {
          setMessage('Account confirmed successfully. You can now login.');
        } else {
          setMessage(data.error || 'Error confirming account.');
        }

      } catch (error) {
        console.error(error);
        setMessage('Server error while confirming account.');
      }

      setLoading(false);
    };

    confirmEmail();
  }, [searchParams]);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      padding: '20px'
    }}>
      {loading && <CircularProgress style={{ marginBottom: '20px' }} />}

      <Typography variant="h5" gutterBottom>
        {message}
      </Typography>

      {!loading && (
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate('/login')}
          style={{ marginTop: '20px' }}
        >
          Go to Login
        </Button>
      )}
    </div>
  );
}

export default ConfirmEmail;